import { decryptionStrings } from '../constants';
/**
 * Validates that an account has a valid token for API operations
 */
export async function validateAccountToken(account, controller, authService) {
    if (!controller) {
        throw new Error(decryptionStrings.errorControllerNotAvailable);
    }
    // Get the current token
    let token = authService.getAccessToken(account.email);
    if (!token) {
        return { requiresManualLogin: true, authorizedAccount: account };
    }
    // Check if token is expired and try to refresh
    const now = new Date();
    if (token.expiration <= now) {
        try {
            token = await authService.refreshAccessToken(account.email);
            if (!token) {
                throw new Error(decryptionStrings.errorAuthenticationFailed);
            }
        }
        catch (refreshError) {
            console.error('Token refresh failed:', refreshError);
            return { requiresManualLogin: true, authorizedAccount: account };
        }
    }
    return {
        token,
        accessToken: token.accessToken
    };
}
